import './AttachFileChatPost.css';
import '@/component/common/AttachFileThumbnail/components/AttachThumbnailList.css';
import Utils from '@/common/utils/utils';
import { PropTypes } from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import useAttachThumbnailSize from '../common/AttachFileThumbnail/handler/useAttachThumbnailSize';
import useAttachThumbnailData from '@/component/common/AttachFileThumbnail/handler/useAttachThumbnailData';
import { THUMBNAIL_SIZE_CLIENT_CONTROL } from '@/component/common/icons/AttachUtils';

/**
 * Message attachments (「メッセージ内添付」) shown on the ticket detail screen.
 *
 * The per-file thumbnail, [more] menu (copy share link / go to message), image preview and
 * download logic all come from the shared `useAttachThumbnailData` hook, the same one the
 * ticket/knowledge list and the "view all" modal use. This component is self-contained: it
 * owns its own Popover and preview dialog through the hook, so the parent screens no longer
 * pass `setOpenPreviewImage` / `setOpenFileOption` / `setOpenOption`.
 */
function AttachFileChatPost({ detailTicket, projectInuseDetail }) {
    const thumbnailSize = useAttachThumbnailSize(THUMBNAIL_SIZE_CLIENT_CONTROL.TICKET_DETAIL);

    const { chatPostFiles, renderThumbnail, dialogs } = useAttachThumbnailData({
        ticketDetail: detailTicket,
        thumbnailSize,
        projectInuseDetail
    });

    // Don't render if there's no message attachment.
    if (Utils.isEmptyArray(chatPostFiles)) {
        return null;
    }

    return (
        <div className="attach-file-chat-post-container">
            <p className="attach-file-chat-post-title">{trI18n('IMG_CHATPOST_FIELD')}</p>

            <div className={`attach-thumbnail-list attach-thumbnail-list--${thumbnailSize}`}>
                <ul>
                    {chatPostFiles.map((file, index) => (
                        <li key={file?.id || file?.originId || index}>
                            {renderThumbnail(file, index)}
                        </li>
                    ))}
                </ul>
            </div>

            {dialogs}
        </div>
    );
}

AttachFileChatPost.propTypes = {
    detailTicket: PropTypes.any,
    setOpenPreviewImage: PropTypes.any,
    setOpenFileOption: PropTypes.any,
    setOpenOption: PropTypes.any,
    projectInuseDetail: PropTypes.any
};

export default AttachFileChatPost;
